import { useRef, useState } from "react";
import { marked } from "marked";
import { useYDoc } from "../hooks/useYDoc";
import { useAutoResize } from "../hooks/useAutoResize";
import { useYText } from "../hooks/useYText";
import { DocMeta } from "../App";
import { Spinner } from "./ui/Spinner";

interface NoteViewProps {
  doc: DocMeta;
  syncVersion?: number;
  onBack: () => void;
}

export function NoteView({ doc, syncVersion, onBack }: NoteViewProps) {
  const { doc: yDoc, loading, error } = useYDoc(doc.docId, syncVersion);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [editing, setEditing] = useState(false);
  const { content, handleChange } = useYText(yDoc, "content");

  useAutoResize(textareaRef, [content, editing]);

  if (loading) return <div className="container"><Spinner /></div>;
  if (error) return <div className="container"><p>Error: {error}</p></div>;
  if (!yDoc) return null;

  return (
    <div className="container" style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, padding: "16px" }}>
      <div className="header-row">
        <h1 className="header-title">{doc.title}</h1>
        <button onClick={onBack} className="btn-close" aria-label="Close">&times;</button>
      </div>

      {editing ? (
        <div className="note-editor-scroll">
          <textarea
            ref={textareaRef}
            value={content}
            onChange={(e) => handleChange(e.target.value)}
            onBlur={() => setEditing(false)}
            placeholder="Start typing..."
            className="note-editor"

          />
        </div>
      ) : content ? (
        // Content is always user-authored within the family; no external input reaches this path.
        <div
          className="note-markdown"
          onClick={() => setEditing(true)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setEditing(true);
            }
          }}
          role="button"
          tabIndex={0}
          dangerouslySetInnerHTML={{ __html: marked.parse(content) as string }}
        />
      ) : (
        <div
          className="note-markdown"
          onClick={() => setEditing(true)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setEditing(true);
            }
          }}
          role="button"
          tabIndex={0}
        >
          <span style={{ color: "var(--color-muted)" }}>Start typing...</span>
        </div>
      )}
    </div>
  );
}
